import { IApplicationState, TBoardId } from '../../../../../../../types/types';
import {
    getUserQualificationFormAnswers
} from '../../../../../../../store/model/authUser/selectors/getUserQualificationFormAnswers';
import { TEMPLATES_SETS } from '../../../constants';
import { isObject } from 'underscore';
import { TQualificationTemplatesSet } from '../../../types';
import {
    getUserQualificationFormStatus
} from '../../../../../../../store/model/authUser/selectors/getUserQualificationFormStatus';
import { EUserMetaQualificationFormStatus } from '../../../../../../../types/rest/IUserMeta';

export const getQualificationTemplateBoardIds = (state: IApplicationState): TBoardId[] => {
    const answers = getUserQualificationFormAnswers(state);
    if (!answers) return;

    const isSkipped = getUserQualificationFormStatus(state) === EUserMetaQualificationFormStatus.SKIPPED;

    let key: string;
    if (answers['templates_help_role_personal'] && answers['templates_help_role_personal'].key) {
        key = answers['templates_help_role_personal'].key;
    } else if (answers['templates_help_func_non_profit'] && answers['templates_help_func_non_profit'].key) {
        key = answers['templates_help_func_non_profit'].key;
    } else if (answers['templates_help_func_business'] && answers['templates_help_func_business'].key) {
        key = answers['templates_help_func_business'].key;
    } else if (answers['templates_help_func_edu'] && answers['templates_help_func_edu'].key) {
        key = answers['templates_help_func_edu'].key;
    } else if (answers['templates_help_role'] && answers['templates_help_role'].key) {
        key = isSkipped ? 'other' : answers['templates_help_role'].key;
    } else if (answers['templates_help_project'] && answers['templates_help_project'].key) {
        key = answers['templates_help_project'].key;
    }

    if (isObject(TEMPLATES_SETS[key])) {
        let roleKey: string;
        if (answers['templates_help_role_edu'] && answers['templates_help_role_edu'].key) {
            roleKey = answers['templates_help_role_edu'].key;
        } else if (answers['templates_help_role_business'] && answers['templates_help_role_business'].key) {
            roleKey = answers['templates_help_role_business'].key;
        } else if (answers['templates_help_role_non_profit'] && answers['templates_help_role_non_profit'].key) {
            roleKey = answers['templates_help_role_non_profit'].key;
        }
        const boardIdsSet = TEMPLATES_SETS[key] as TQualificationTemplatesSet;
        return boardIdsSet[roleKey] as TBoardId[];
    } else {
        return [TEMPLATES_SETS[key]] as TBoardId[];
    }
}
